import React from "react";
import type { RegionGroup } from "../../config/deploymentRegions";
import CreateDeploymentFormLegacy from "./CreateDeploymentFormLegacy";
import CreateDeploymentFormRegional from "./CreateDeploymentFormRegional";

export interface CreateDeploymentFormProps {
  onCancel: () => void;
  onSuccess?: () => void;
  basePath: string;
  resourceAppId: string;
  version: string;
  /** develop (flag off): passed from DeploymentCreator */
  availableRegions?: { key: string; value: string }[];
  /** Figma (flag on): region groups for drawer */
  regionGroups?: RegionGroup[];
  /** Regions already deployed for this version (regional add flow) */
  deployedRegions?: string[];
}

const supportRegionalDeployments =
  process.env.REACT_APP_SUPPORT_REGIONAL_DEPLOYMENTS === "true";

const CreateDeploymentForm: React.FC<CreateDeploymentFormProps> = (props) => {
  if (!supportRegionalDeployments) {
    const regions = props.availableRegions ?? [];
    return (
      <CreateDeploymentFormLegacy
        onCancel={props.onCancel}
        onSuccess={props.onSuccess}
        basePath={props.basePath}
        resourceAppId={props.resourceAppId}
        version={props.version}
        availableRegions={regions}
      />
    );
  }

  return (
    <CreateDeploymentFormRegional
      onCancel={props.onCancel}
      onSuccess={props.onSuccess}
      basePath={props.basePath}
      resourceAppId={props.resourceAppId}
      version={props.version}
      regionGroups={props.regionGroups}
      deployedRegions={props.deployedRegions}
    />
  );
};

export default CreateDeploymentForm;
